import React, { useState } from "react";
import "./OTPModal.css";

const OTPModal = ({ login, handleCancel }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleOTPSubmit = async (event) => {
    event.preventDefault();
    const otp = event.target.otp.value;
    if (!otp) return;
    setSubmitting(true);
    try {
      login.emit("verify-email-otp", otp);
    } catch (err) {
      console.error("Error confirming OTP:", err);
      setSubmitting(false);
    }
  };

  return (
    <div className="otp-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="otp-title">
      <div className="otp-modal fade-in">
        <div className="otp-brand">
          <span>CMBS</span><span className="otp-brand-accent">DLT</span>
        </div>
        <h2 id="otp-title" className="otp-title">Enter verification code</h2>
        <p className="otp-sub">We sent a 6-digit code to your email. It expires in a few minutes.</p>

        <form onSubmit={handleOTPSubmit} className="otp-form">
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            name="otp"
            placeholder="• • • • • •"
            required
            autoFocus
            maxLength={8}
            className="otp-input"
            aria-label="One-time passcode"
          />
          <button type="submit" className="otp-btn otp-btn-primary" disabled={submitting}>
            {submitting ? (<><span className="otp-spinner" /> Verifying…</>) : "Verify"}
          </button>
          <button type="button" onClick={handleCancel} className="otp-btn otp-btn-ghost">
            Cancel
          </button>
        </form>

        <div className="otp-terms">
          <a href="#">Privacy</a><span>•</span><a href="#">Terms</a>
        </div>
      </div>
    </div>
  );
};

export default OTPModal;
